import React from 'react'
import { Divider, Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import TableAAPP from '../../Tables/TableAAPP'

import { useStyles } from '../styles'

const MarketsByRegionsCard = (props) => {
  const { selectedDate, regions = [], gRegionB, gRegionA = [] } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total mercado por regiones</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
           <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP
              array={regions}
              param="TERRITORIO"
              selectedDate={selectedDate}
              title="Región"
              AA
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <h3>Evolución de pesos por región año</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(
                gRegionA,
                'territorio',
                'PORCENTAJE',
                'y',
                '100',
              )}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Divider />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <h3>Evolución de pesos por región mes</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(
                gRegionB,
                'TERRITORIO',
                'PORCENTAJE',
                'MESC',
                '100',
              )}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MarketsByRegionsCard
